import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  accountFromEnvelope,
  getBusinessAccount,
  loadSetupChecklist,
} from '../features/signup-setup/signupSetupApi.js';
import { landingPathForAccount } from '../shell/businessLanding.js';

/** `/` — checklist until the account is live, then overview (07-09). */
export function LandingRedirect() {
  const accountQuery = useQuery({
    queryKey: ['business', 'account', 'landing'],
    queryFn: () => getBusinessAccount(),
    staleTime: 60_000,
  });
  const checklistQuery = useQuery({
    queryKey: ['business', 'setup-checklist', 'landing'],
    queryFn: () => loadSetupChecklist(),
    staleTime: 60_000,
  });

  if (accountQuery.isLoading || checklistQuery.isLoading) {
    return <p role="status">Opening your account…</p>;
  }

  const account = accountFromEnvelope(accountQuery.data) ?? checklistQuery.data?.account;
  const to = landingPathForAccount({
    status: account?.status,
    state: account?.state,
    onboardedAt: account?.onboardedAt,
    setupProgress: account?.setupProgress,
    checklistProgress: checklistQuery.data?.progress,
  });

  return <Navigate to={to} replace />;
}
